import { compilationThemeIds } from "@memento/types/compilation-theme";
const allThemes = compilationThemeIds;
// These are songs that can be used for any occasion. Note that it isn't every
// song; some are missing (e.g. holiday-specific songs).
const allOccasionsSongs = [
    "a-minor-waltz",
    "avocado-street",
    "ballerina",
    "boardroom-theme",
    "bright-skies",
    "campfire-song",
    "corndogs-in-santa-monica",
    "cute-avalanche",
    "daleys-reel",
    "distance",
    "dome-sweet-dome",
    "dulcinea",
    "dutty",
    "esthers-waltz",
    "fond-memories",
    "fun-activity",
    "get-outside",
    "glen-canyon",
    "good-times",
    "happy-mistake",
    "homebound",
    "jack-in-the-box",
    "longer-distance",
    "morning-mandolin",
    "mosswood",
    "mr-sunny-face",
    "new-year",
    "piano-journey",
    "put-on-your-dancing-pants",
    "roll-and-drop",
    "rolling-heads",
    "ruination",
    "safety-net",
    "silence-for-a-film",
    "smile-quiet-looking-up",
    "southern-california",
    "spring-in-my-step",
    "strong-bones",
    "sunshine",
    "swoop",
    "take-me-out-to-the-ballgame",
    "the-creek",
    "the-only-girl",
    "venice-beach",
    "water-lily",
    "winds-of-spring",
    "yellow-jello",
];
// The `themes` property will be presented to the user in the order listed here.
export const compilationOccasions = [
    {
        version: 1,
        occasionId: "birthday",
        name: "Birthday",
        themes: [
            "birthday-balloons",
            "birthday-cake",
            "birthday-candles",
            "paint-daubs",
            "star-pop",
            "big-congrats",
        ],
        songs: [
            "birthday-cake",
            "happy-birthday-bossanova",
            "happy-birthday-bouncy",
            "happy-birthday-funk",
            "happy-birthday-jazz-waltz",
            "happy-birthday-mambo",
            "happy-birthday-soul",
        ],
    },
    {
        version: 1,
        occasionId: "wedding",
        name: "Wedding",
        themes: [
            "wedding-guest-book",
            "inky-guest-book",
            "wedding-cream-and-gold",
            "wedding-garden-rose",
            "wedding-garden-script",
            "wedding-spring-greenery",
            "wedding-natural",
            "pop-hearts",
            "meadow-flowers",
            "windflower",
        ],
        songs: [
            "a-minor-waltz",
            "bright-skies",
            "building-blocks",
            "chords-of-harmony",
            "cute-avalanche",
            "distance",
            "dulcinea",
            "dutty",
            "esthers-waltz",
            "first-love",
            "fond-memories",
            "glen-canyon",
            "homebound",
            "longer-distance",
            "morning-mandolin",
            "mosswood",
            "piano-journey",
            "silence-for-a-film",
            "swoop",
            "ukulele-beach",
            "wigs",
            "wish-youd-come-true",
        ],
    },
    {
        version: 1,
        occasionId: "anniversary",
        name: "Anniversary",
        themes: [
            "pop-hearts",
            "wedding-guest-book",
            "inky-guest-book",
            "wedding-cream-and-gold",
            "wedding-garden-rose",
            "wedding-garden-script",
            "wedding-spring-greenery",
            "wedding-natural",
            "meadow-flowers",
            "windflower",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "graduation",
        name: "Graduation",
        themes: [
            "star-pop",
            "diamond-congrats",
            "vintage-symmetry",
            "general-solid",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "retirement",
        name: "Retirement",
        themes: [
            "mountain-view",
            "doodle-coffee",
            "star-pop",
            "diamond-congrats",
            "vintage-symmetry",
            "general-solid",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "baby",
        name: "Baby",
        themes: ["paint-daubs", "pop-hearts", "star-pop"],
        songs: [
            "a-minor-waltz",
            "bright-skies",
            "building-blocks",
            "chords-of-harmony",
            "cute-avalanche",
            "distance",
            "dulcinea",
            "dutty",
            "esthers-waltz",
            "first-love",
            "fond-memories",
            "glen-canyon",
            "homebound",
            "longer-distance",
            "morning-mandolin",
            "mosswood",
            "piano-journey",
            "silence-for-a-film",
            "swoop",
            "ukulele-beach",
            "wigs",
            "wish-youd-come-true",
        ],
    },
    {
        version: 1,
        occasionId: "workplace",
        name: "Workplace",
        themes: [
            "doodle-coffee",
            "star-pop",
            "diamond-congrats",
            "vintage-symmetry",
            "general-solid",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "teacher",
        name: "Teacher",
        themes: [
            "school-spirit",
            "star-pop",
            "paint-daubs",
            "doodle-coffee",
            "general-solid",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "in-memory-of",
        name: "In Memory Of",
        themes: [
            "meadow-flowers",
            "windflower",
            "diamond-congrats",
            "general-solid",
        ],
        songs: [...allOccasionsSongs],
    },
    {
        version: 1,
        occasionId: "holiday",
        name: "Holiday",
        themes: [
            "holiday-snow",
            "christmas-presents",
            "mountain-view",
            "diamond-congrats",
            "vintage-symmetry",
            "general-solid",
        ],
        songs: [
            "auld-lang-syne",
            "christmas-village",
            "deck-the-halls",
            "i-have-a-little-dreidel",
            "jingle-bells",
            "joy-to-the-world",
            "o-christmas-tree",
            "we-wish-you-a-merry-christmas",
        ],
    },
    {
        version: 1,
        occasionId: "other",
        name: "Other",
        themes: [...allThemes],
        songs: [...allOccasionsSongs],
    },
];
